import { collectionsMap } from "@/data/CollectionsMap.ts";
import { deleteMany } from "@/data/data-utils.ts";

export async function deleteCreatedMenuUser() {
  for (const collectionItem of collectionsMap()) {
    if (collectionItem.menuUserCreated) {
      await deleteMany(collectionItem.collection, {}, true)
    }
  }
}